<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="30%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="category_id">
        <el-select v-model="formData.category_id" placeholder="选择分类" filterable>
          <el-option label="选择分类" :value="0"></el-option>
          <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年份" prop="year">
        <el-input-number v-model="formData.year" :min="1" :max="5000"></el-input-number>
      </el-form-item>
      <el-form-item label="发布时间" prop="publish_time">
        <el-date-picker v-model="formData.publish_time" type="datetime" value-format="timestamp" placeholder="选择发布时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="图片" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/upload_img2222"
            name="img"
            :show-file-list="false"
            :before-upload="handleUpload"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl+'?imageView2/0/w/50'" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="简介" prop="intro">
        <el-input v-model="formData.intro" type="textarea" :rows="3"></el-input>
      </el-form-item>
<!--      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :min="0" :max="65535"></el-input-number>
        <span style="margin-left: 10px; color: #909399; font-size: 12px;">越大越靠前</span>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as qiniu from 'qiniu-js'
import md5 from 'js-md5'
export default {
  name: 'special_add',
  props: [
    'visible', 'id', 'categoryList'
  ],
  data () {
    return {
      title: '添加专题',
      uploadPrepareResp: {},
      formData: {
        title: '',
        series_id: 0,
        category_id: 0,
        year: 0,
        publish_time: null,
        pic: '',
        intro: ''
        // sort: 0
      },
      picUrl: '',
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.formData = {
        title: '',
        series_id: 0,
        year: 0,
        publish_time: null,
        pic: '',
        intro: '',
        sort: 0
      }
      this.picUrl = ''
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        const data = Object.assign({}, this.formData, { publish_time: this.formData.publish_time ? Math.floor(this.formData.publish_time / 1000) : 0 })
        if (this.id === 0) {
          this.$emit('add', data)
        } else {
          this.$emit('update', this.id, data)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑专题'
        this.getInfo(this.id)
      } else {
        this.formData.year = new Date().getFullYear()
        this.title = '添加专题'
      }
      this.uplodPrepare()
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/special/info/' + id)
      if (res.code === 0 && res.data) {
        // Update existing reactive fields rather than replacing the form model,
        // so Element UI controls (especially date-picker) receive the values.
        this.$set(this.formData, 'title', res.data.title || '')
        this.$set(this.formData, 'series_id', res.data.series_id || 0)
        this.$set(this.formData, 'category_id', res.data.category_id || 0)
        this.$set(this.formData, 'year', res.data.year || 0)
        this.$set(this.formData, 'serial_no', res.data.serial_no || 0)
        this.$set(this.formData, 'publish_time', res.data.publish_time ? Number(res.data.publish_time) * 1000 : null)
        this.$set(this.formData, 'pic', res.data.pic || '')
        this.$set(this.formData, 'intro', res.data.intro || '')
        this.$set(this.formData, 'sort', Number(res.data.sort) || 0)
        this.picUrl = res.data.pic_url || ''
      } else {
        this.$message.error(res.msg || '获取主题封面信息失败')
      }
    },
    async uplodPrepare (fileName) {
      const res = await this.$http.get('/admin/upload_prepare')
      if (res.code === 0) {
        this.uploadPrepareResp = res.data
      }
    },
    handleUpload (file) {
      const fileNameArr = file.name.split('.')
      const key = 'image/' + this.getDateString() + '/' + md5(file.name + Date.now()) + '.' + fileNameArr[1]
      const putExtra = { fname: key }
      const config = { useCdnDomain: true, region: qiniu.region.z0 } // 根据需要选择区域
      const observable = qiniu.upload(file, key, this.uploadPrepareResp.up_token, putExtra, config)
      this.uploading = 1
      const next = (res) => {
        // 可以在这里添加上传进度条更新的代码
        this.upPercent = Math.ceil(res.total.percent)
      }
      const error = (err) => {
        this.$message.error(err.message)
      }
      const complete = (res) => {
        // 上传完成后的处理逻辑
        this.upPercent = 100
        this.uploading = 0
        this.formData.pic = res.key
        this.picUrl = this.uploadPrepareResp.res_domain + res.key
      }
      observable.subscribe({ next, error, complete })
      this.uplodPrepare()
      return false
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    },
    getDateString () {
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}${month}${day}`
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
.avatar {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
